
import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, Link } from "react-router-dom";


import {
    createConvenienceAndCharge,
    updateConvenienceAndCharge,
    getConvenienceAndChargeId
} from "../../services/userservice";

import { setEditingCategory, setEditingCategoryId, setError, setLoading } from "../../features/common/categorySlice";


const AddConvenienceFeesAndCharges = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isEditMode, setIsEditMode] = useState(false);
    const { loading, error, editingCategory } = useSelector((state) => state.category);

    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState([
        {
            title: "", discount_type: "", value: "", category: "", status: "",  min_order_value:0,
            max_order_value:0
        },
    ]);


    useEffect(() => {
        if (id && id !== "add" && editingCategory !== id) {
            dispatch(setEditingCategoryId(id));
            dispatch(setEditingCategory(id));
            setIsEditMode(true);
            fetchUserData(id);
        }
    }, [id, editingCategory, dispatch]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const formDataToSend = {
                ...formData,
            };
            dispatch(setLoading(true));
            const response =
                id && id !== "add"
                    ? await updateConvenienceAndCharge(id, formDataToSend)
                    : await createConvenienceAndCharge(formDataToSend);
            navigate("/convenience-fees-and-charges-list");
            console.log("response", response)
        } catch (error) {
            dispatch(setError(error.message));
            alert(error.message);

            dispatch(setLoading(false));
        }
    };

    const fetchUserData = async (id) => {
        try {
            dispatch(setLoading());
            const response = await getConvenienceAndChargeId(id);
            if (response) {
                const responseData = response;
                setFormData({
                    title: responseData?.title,
                    discount_type: responseData?.discount_type,
                    value: responseData?.value,
                    status: responseData?.status,
                    category: responseData?.category,
                    type:responseData?.type,
                    min_order_value: parseInt(responseData?.min_order_value),
                    max_order_value:parseInt(responseData?.max_order_value),
                });
                dispatch(setLoading(false));
            }
        } catch (error) {
            dispatch(setError(error.message));
        } finally {
            dispatch(setLoading(false));
        }
    };

    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;
    //     setFormData((prevFormData) => ({
    //         ...prevFormData,
    //         [name]: value,
    //     }));
    // };

    const handleInputChange = (event) => {
        const { name, value } = event.target;

        if (name === "discount_type") {
            setFormData({
                ...formData,
                [name]: value,
                value: "",
            });
        }else if (name === "min_order_value" || name === "max_order_value") {
            if (/^\d*\.?\d*$/.test(value)) {
                setFormData({
                    ...formData,
                    [name]: +value
                });
            }
        } else {
            let newValue = value;

            if (formData.discount_type === "PERCENTAGE") {
                if (newValue > 100) {
                    return;
                }
            } else if (formData.discount_type === "AMOUNT") {
                if (newValue > 1000) {
                    return;
                }
            }
            setFormData({
                ...formData,
                [name]: newValue,
            });
        }
    };


    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Convenience Fees</h1>
                        </div>

                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Home</Link>
                                </li>
                                <li className="breadcrumb-item active">Convenience Fees</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <section className="content">
                <div className="container-fluid">
                    <div classname="row">
                        <div className="col-md-12">
                            <form onSubmit={handleSubmit}>
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row">

                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Convenience Fees Title</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="exampleInputEmail1"
                                                        placeholder="Enter Convenience Fees Title"
                                                        name="title"
                                                        value={formData.title}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Calculation</label>
                                                    <select
                                                        className="form-control"
                                                        id="discountType"
                                                        name="discount_type"
                                                        value={formData.discount_type}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="PERCENTAGE">PERCENTAGE</option>
                                                        <option value="AMOUNT">AMOUNT</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Type</label>
                                                    <select
                                                        className="form-control"
                                                        id="type"
                                                        name="type"
                                                        value={formData.type}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="charge">Charge</option>
                                                        <option value="discount">Discount</option>
                                                    </select>
                                                </div>
                                            </div>


                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Value</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        id="value"
                                                        placeholder="Enter Value"
                                                        name="value"
                                                        value={formData.value}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label htmlFor="min_order_value">Minimum Order Value</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        id="min_order_value"
                                                        placeholder="Minimum Order Value"
                                                        name="min_order_value"
                                                        value={formData.min_order_value}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label htmlFor="max_order_value">Maximum Order Value</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        id="max_order_value"
                                                        placeholder="Minimum Order Value"
                                                        name="max_order_value"
                                                        value={formData.max_order_value}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label>Category</label>
                                                    <select
                                                        className="form-control"
                                                        id="category"
                                                        name="category"
                                                        value={formData.category}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Select Category</option>
                                                        <option value="flight">FLIGHT</option>
                                                        <option value="hotel">HOTEL</option>
                                                    </select>
                                                </div>
                                            </div>
                                            
                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label>Status</label>
                                                    <select
                                                        className="form-control"
                                                        id="status"
                                                        name="status"
                                                        value={formData.status}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="active">Active</option>
                                                        <option value="inactive">Inactive</option>
                                                    </select>
                                                </div>
                                            </div>

                                        </div>


                                    </div>
                                    <div class="card-footer">
                                        <button type="submit" className="btn btn-primary">
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>




        </div>
    );
};

export default AddConvenienceFeesAndCharges;